"use client";

import Link from "next/link";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { trackMarketingEvent } from "@/lib/features/marketing/client/events";
import type { CtaConfig } from "@/lib/features/marketing/shared/types";

interface CtaButtonProps {
  cta: CtaConfig;
  variant?: "primary" | "secondary";
  size?: "default" | "lg" | "sm";
  className?: string;
}

export function CtaButton({
  cta,
  variant = "primary",
  size = "lg",
  className,
}: CtaButtonProps) {
  return (
    <Button
      asChild
      size={size}
      variant={variant === "primary" ? "default" : "outline"}
      className={cn(
        // Marketing surfaces are near-black; strengthen the outline-variant
        // contrast so the secondary CTA reads as a real action rather than a
        // ghost.
        variant === "secondary" &&
          "border-foreground/30 bg-background/40 text-foreground hover:bg-background/80 hover:border-foreground/50",
        className,
      )}
    >
      <Link
        href={cta.href}
        onClick={() => {
          trackMarketingEvent("marketing_cta_clicked", {
            cta_id: cta.id,
            destination: cta.href,
          });
        }}
      >
        {cta.label}
      </Link>
    </Button>
  );
}
